import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from "clsx";
import { memo } from "react";
import { OverflowingTypography } from "./OverflowingTypography";
import { TextField } from "./TextField";
import { textInputBaseSlots } from "./TextInputBase";
import { SlotsProvider } from "../providers/SlotsProvider";
import { mergeSx } from "../system";
export const urlFieldClasses = {
    root: "MinervaUrlField-root",
};
export const urlFieldSlots = {
    prefix: OverflowingTypography,
    postfix: OverflowingTypography,
};
export const UrlField = memo(({ prefix, postfix, slots, slotProps, className, ...rest }) => {
    return (_jsx(SlotsProvider, { baseSlots: { ...urlFieldSlots, ...textInputBaseSlots }, slots: slots, children: ({ prefix: Prefix, postfix: Postfix, ...inputSlots }) => {
            return (_jsx(TextField, { className: clsx([urlFieldClasses.root, className]), type: "url", slots: inputSlots, slotProps: slotProps, startNode: typeof prefix === "string" ? (_jsx(Prefix, { variant: "body3", ...slotProps?.prefix, sx: mergeSx({
                        maxWidth: 20,
                    }, slotProps?.prefix?.sx), children: prefix })) : (prefix), endNode: typeof postfix === "string" ? (_jsx(Postfix, { variant: "body3", ...slotProps?.postfix, sx: mergeSx({
                        maxWidth: 20,
                    }, slotProps?.postfix?.sx), children: postfix })) : (postfix), ...rest }));
        } }));
});
//# sourceMappingURL=UrlField.js.map